import { DocumentChangeInterface, OperationTypeEnum } from "@finway-group/shared/lib/models"

import { fetchCurrencyExchange } from "Shared/store/actions/currency/currencyActions"

const subscribeToCurrencyExchange = (dispatch: any, data: DocumentChangeInterface) => {
    const {
        fullDocument: { operationType },
    } = data

    if (operationType === OperationTypeEnum.INSERT || operationType === OperationTypeEnum.UPDATE) {
        dispatch(fetchCurrencyExchange())
    }
}

export default subscribeToCurrencyExchange
